// extracted by mini-css-extract-plugin
module.exports = {"container":"guides-module--container--Uqehu","textContainer":"guides-module--textContainer--1Ejev","form":"guides-module--form--PKLWA"};